import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const FAQS = [
    {
        question: "What is Drive.Day?",
        answer:
            "An app for driving instructors and driving schools. Manage pupils, book and track lessons, record payments and keep your diary organised, whether you work alone or run a team of instructors.",
    },
    {
        question: "How do I sign in?",
        answer:
            "With your mobile number. Enter it in the app and we'll text you a code to confirm it's you, so there's no password to remember.",
    },
    {
        question: "How do I add a new pupil?",
        answer:
            "Open the Pupils tab and tap + in the top-right. Add their name and mobile number, plus addresses, tags and anything else you want to keep on file.",
    },
    {
        question: "What can I see on a pupil's profile?",
        answer:
            "Everything in one place: their credit, hours delivered and booked, next lesson, test details, tags and notes. Tabs take you to their details, money, lessons, progress and documents.",
    },
    {
        question: "How do I book a lesson?",
        answer:
            "Tap a free slot in your diary and choose Lesson, or book from the pupil's Lessons tab. Pick the date, time, lesson type and pickup address, then save.",
    },
    {
        question: "Can I change a lesson after booking it?",
        answer:
            "Yes. Tap the lesson in your diary and choose Modify lesson. For a quick change, press and hold the lesson to drag it to a new time or change how long it is.",
    },
    {
        question: "What happens when I cancel a lesson?",
        answer:
            "You can turn the cancelled lesson into an open gap, so the slot stays free and you can offer it to other pupils.",
    },
    {
        question: "How do I record a payment?",
        answer:
            "Add a payment to the pupil with the amount and the hours of credit it buys. Their balance updates straight away.",
    },
    {
        question: "How does pupil credit work?",
        answer:
            "Credit is held in hours. Each lesson you deliver comes off the pupil's balance, so you can always see who's paid up and who's running low.",
    },
    {
        question: "How do I see what money has come in?",
        answer:
            "The Money area lists every payment with a running income total, and Credit balances shows how many hours each pupil has left.",
    },
    {
        question: "How do I invite an instructor to my school?",
        answer:
            "Go to Settings → You & your school → Instructors / admin, tap + and enter their mobile number. They'll show as Invited until they accept.",
    },
    {
        question: "What's the difference between Owner, Admin and Member?",
        answer:
            "The Owner holds the account and has full control. Admins can manage the school and its instructors. Members are instructors who run their own diary and pupils. One plan covers everyone.",
    },
    {
        question: "What do I do with a new enquiry?",
        answer:
            "Enquiries arrive in Messages under Enquiries. Open one, check the details and tap Add as pupil to put them on your waiting list, ready to assign to an instructor.",
    },
    {
        question: "Can I see my instructors' diaries?",
        answer:
            "Yes. Tap the black school button on your diary to switch to the school view, then show everyone or filter to one instructor from the bar at the top. Tap the red X to go back to your own diary.",
    },
    {
        question: "I can't see school mode. Where is it?",
        answer:
            "School mode switches on automatically as soon as your school has more than one user. Invite an instructor or admin, and once they've accepted, the school view appears on your diary.",
    },
    {
        question: "Where do I set my working hours and lesson types?",
        answer:
            "In Settings → Diary & availability. Set when you're available and customise your lesson types there.",
    },
];

// two columns: the first half on the left, the rest on the right
const COLUMNS = [FAQS.slice(0, Math.ceil(FAQS.length / 2)), FAQS.slice(Math.ceil(FAQS.length / 2))];

function FaqHomeOne({ className }) {
    const [showQues, setQues] = useState(0);
    let index = 0;
    return (
        <>
            <section className={`dd-faq-area pb-95 pt-90 ${className || ''}`} id="faq">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="dd-section-title text-center">
                                <h3 className="dd-title">Frequently asked questions</h3>
                                <p>Quick answers to the questions we get asked most.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {COLUMNS.map((column, c) => (
                            <div className="col-lg-6" key={c}>
                                <div
                                    className="faq-accordion wow fadeInRight mt-30"
                                    data-wow-duration="1500ms"
                                >
                                    <div
                                        className="accrodion-grp animated fadeIn faq-accrodion wow"
                                        data-wow-duration="1500ms"
                                        data-grp-name="faq-accrodion"
                                    >
                                        {column.map((faq) => {
                                            const i = index++;
                                            return (
                                                <div
                                                    key={faq.question}
                                                    onClick={() => setQues(i)}
                                                    className={`accrodion ${showQues === i ? 'active' : ''}`}
                                                >
                                                    <div className="accrodion-inner">
                                                        <div className="accrodion-title">
                                                            <h4>{faq.question}</h4>
                                                        </div>
                                                        <div
                                                            className="accrodion-content"
                                                            style={{
                                                                display: showQues === i ? 'block' : 'none',
                                                            }}
                                                        >
                                                            <div className="inner">
                                                                <p>{faq.answer}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className="col-lg-12">
                            <div className="faq-text text-center pt-40">
                                <p>
                                    Can&apos;t find an answer?{' '}
                                    <Link to="/contact">Contact us</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default FaqHomeOne;
